import Title from "@/components/common/Title";
import { Form } from "@/components/ui/form";
import useSelectOrganisationById from "@/features/auth/api/selectOrganisationById";
import SelectRole from "@/features/invite/components/SelectRole";
import SelectFromMyOrganisationIds from "@/features/organisations/components/SelectFromMyOrganisationIds";
import QRCodeRoute from "@/features/qr-code/components/QrCodeRoute";
import type { RoleT } from "@/types";
import { QrCode } from "lucide-react";
import { useForm } from "react-hook-form";
import Call from "../../../components/common/Call";
interface Props {
    defaultRole: RoleT;
    defaultOrganisationId: string;
}

const QrCodeInviteForm = ({ defaultRole, defaultOrganisationId }: Props) => {
    const { data: organisation } = useSelectOrganisationById(
        defaultOrganisationId,
    );
    const form = useForm({
        defaultValues: {
            role: defaultRole ?? "PATIENT",
            organisation_id: defaultOrganisationId,
        },
    });

    return (
        <div className="flex flex-col justify-center items-center gap-8 mx-auto py-8 max-w-md min-h-screen">
            <Form {...form}>
                <form className="flex flex-col md:flex-col gap-x-2 gap-y-0 w-full">
                    <SelectRole />
                    <SelectFromMyOrganisationIds />
                </form>
            </Form>
            {form.watch(
                    "organisation_id",
                )
                ? (
                    <QRCodeRoute
                        route={{
                            to: "/signup",
                            search: {
                                role: form.watch("role").toUpperCase(),
                                organisation_id: form.watch(
                                    "organisation_id",
                                ),
                                organisation: {
                                    organisation_id: form.watch(
                                        "organisation_id",
                                    ),
                                    organisation_name: organisation
                                        ?.organisation_name,
                                },
                            },
                        }}
                        title={`Signup as a ${
                            form.watch("role")?.toLowerCase()
                        } in ${organisation?.organisation_name}`}
                    />
                )
                : (
                    <Call
                        icon={<QrCode />}
                        words="Please select an organisation and role to generate the QR Code"
                    />
                )}
        </div>
    );
};

export default QrCodeInviteForm;
